import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50/80">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-16" style={{ maxWidth: '1400px' }}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Logo and description */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold tracking-wider text-background-50">Художественная ковка</span>
              <span className="block text-xs tracking-[0.2em] uppercase text-background-50/50 mt-1">мастерская металла</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60 mt-3 max-w-xs">
              Изготовление и монтаж металлоконструкций под ключ в Приютово, Белебее, Ермекеево, Бижбуляке, Абдулино, Пономарёвке, Матвеевке, Новомихайловке, Бавлах, Бугуруслане, Киргиз-Мияках, Туймазах, Октябрьском, Буздяке, Кандрах, Давлеканово, Раевке, Уфе и Чишмах.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4 tracking-wide">Меню</h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">Главная</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">О компании</Link></li>
              <li><Link to="/contacts" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">Контакты</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4 tracking-wide">Изделия</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              <Link to="/products/carports" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Навесы (машин)</Link>
              <Link to="/products/gazebos" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Беседки</Link>
              <Link to="/products/gates" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Ворота и калитки</Link>
              <Link to="/products/bbq" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Мангальные зоны</Link>
              <Link to="/products/grave-fences" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Кованые оградки</Link>
              <Link to="/products/railings" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Перила</Link>
              <Link to="/products/fireplace-sets" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Каминные наборы</Link>
              <Link to="/products/wrought-furniture" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Кованная мебель</Link>
              <Link to="/products/window-grilles" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Решётки для окон</Link>
              <Link to="/products/swings" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Качели</Link>
              <Link to="/products/benches" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">Скамейки</Link>
            </div>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4 tracking-wide">Свяжитесь с нами</h4>
            <a href="tel:+79174131562" className="flex items-center gap-2 text-lg font-semibold text-background-50 hover:text-primary-400 transition-colors mb-3">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </span>
              +7 917 413-15-62
            </a>
            <p className="text-sm text-background-50/60 mb-4">Ежедневно, 9:00–18:00</p>
            <div className="flex items-center gap-3 flex-wrap">
              <a
                href="https://wa.me/79174131562"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 text-background-50 transition-all duration-300"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a
                href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 text-background-50 transition-all duration-300"
                aria-label="MAX"
              >
                <i className="ri-chat-3-line text-lg"></i>
              </a>
              <a
                href="https://t.me/Gmgmg0202"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 text-background-50 transition-all duration-300"
                aria-label="Telegram"
              >
                <i className="ri-telegram-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} Художественная ковка. Все права защищены.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/privacy-policy" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap">Политика конфиденциальности</Link>
            <span className="text-background-50/20 text-xs">|</span>
            <Link to="/data-policy" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap">Политика обработки данных</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}